import React, { Fragment } from 'react'
import { Container, Grid, Paper, Typography, Fade } from '@mui/material'
import { PickingReportSearch } from './PickingReportSearch/PickingReportSearch'
import { PickingCards } from './PickingStatesSquare/PickingCards'
import { PickingStatesSquare } from './PickingStatesSquare/PickingStatesSquare'
import { SnackBar } from '../../SnackBar/Snackbar'
import { usePickingReport } from '../Context/usePickingReport'
import { PickingReportBusiness } from '../actions/PickingReportBusiness'
import { useStyles } from './style'
import { graphLoader } from '../../../images/graphLoader'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea reporte de picking
*/

export const PickingReportWrapper = () => {
  const {
    state: { snackbar, loading }
  } = usePickingReport()
  const classes = useStyles()
  const { handleSetSnackbar } = PickingReportBusiness()

  return (
    <Container maxWidth='xl'>
      <Typography variant='h4' component='h2' gutterBottom>
        Avances de Picking
      </Typography>

      <Paper elevation={1}>
        <PickingReportSearch />

        {loading ? (
          <Fade in={true}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12} style={{ textAlign: 'center' }}>
                <img
                  src={graphLoader}
                  alt='graph'
                  style={{
                    width: '211px',
                    height: '200px',
                    maxWidth: '211px',
                    minWidth: '200px',
                    opacity: '1',
                    borderRadius: '100px'
                  }}
                />
                <Typography
                  variant='h4'
                  color='textSecondary'
                  component='h4'
                  className={classes.textColor}
                >
                  {'Generando Reporte...'}
                </Typography>
              </Grid>
            </Grid>
          </Fade>
        ) : (
          <Fade in={true}>
            <Fragment>
              <PickingCards />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '300px',
                  paddingBottom: '40px'
                }}
              >
                <PickingStatesSquare />
              </div>
            </Fragment>
          </Fade>
        )}
      </Paper>

      <SnackBar
        message={snackbar.message}
        open={snackbar.open}
        setOpen={() =>
          handleSetSnackbar({
            message: snackbar.message,
            open: false,
            status: snackbar.status
          })
        }
        status={snackbar.status}
        autoHideDuration={3500}
      />
    </Container>
  )
}
